import React from "react";
// import PropTypes, { string } from 'prop-types';

import "../Input.scss";

interface CustomProps {
  default?: string;
  name?: string;
  placeholder?: string;
  autoComplete?: string;
  label?: string;
  gap?: "sm" | "md" | "lg";
  size?: "lg" | "sm";
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  classes?: string;
  showAsterisk?: boolean;
  showVisibilityButton?: boolean;
}

interface CustomState {
  value?: string;
  showPassword?: boolean;
}

class PasswordInput extends React.Component<CustomProps, CustomState> {
  static defaultProps: Partial<CustomProps> = {
    default: "",
    name: "",
    label: "",
    placeholder: "",
    gap: "md",
    size: "sm",
    onChange: () => {
      return;
    },
    error: "",
    disabled: false,
    classes: "",
    showVisibilityButton: false,
  };
  constructor(props: CustomProps) {
    super(props);
    this.state = {
      value: props.default,
      showPassword: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.toggleVisibility = this.toggleVisibility.bind(this);
  }

  componentDidUpdate(prevProps: CustomProps) {
    if (prevProps.default !== this.props.default) {
      this.updateDefault();
    }
  }

  updateDefault() {
    // console.log('2. this.props.default(PasswordInput): ', this.props.default);
    if (this.props.default !== undefined) {
      this.setState({ value: this.props.default });
      this.props.onChange(this.props.default);
    }
  }

  handleChange(e: { target: any }) {
    const { value } = e.target;
    this.setState({ value });
    this.props.onChange(value);
  }

  toggleVisibility() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  render() {
    const {
      size,
      label,
      placeholder,
      name,
      gap,
      error,
      disabled,
      autoComplete,
      showAsterisk,
      showVisibilityButton,
    } = this.props;
    const extraClassesInput: string[] = [];
    if (size === "lg") extraClassesInput.push("Input__field--lg");
    if (size === "sm") extraClassesInput.push("Input__field--sm");
    const extraClasses = extraClassesInput.join(" ");
    const inputIdCandidate = name || label || placeholder || "";
    const inputId = inputIdCandidate.toLowerCase().split(" ").join("-");
    return (
      <div className={`Input Input--gap-${gap}`}>
        {label && (
          <label className="Input__label" htmlFor={inputId}>
            {label}
            {showAsterisk === true ? (
              <span className="text-danger">*</span>
            ) : null}
          </label>
        )}
        <div className="position-relative">
          <input
            id={inputId}
            className={this.props.classes || `Input__field ${extraClasses}`}
            type={
              showVisibilityButton && this?.state?.showPassword
                ? "text"
                : "password"
            }
            placeholder={placeholder}
            onChange={this.handleChange}
            value={this.state.value}
            disabled={disabled}
            autoComplete={autoComplete}
          />
          {showVisibilityButton && (
            <div onClick={this.toggleVisibility} className="visibility-button text-gray-700">
              {this?.state?.showPassword ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  width="20"
                  height="20"
                  stroke-width="2"
                >
                  <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                  <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path>
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  width="20"
                  height="20"
                  stroke-width="2"
                >
                  <path d="M10.585 10.587a2 2 0 0 0 2.829 2.828"></path>
                  <path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87"></path>
                  <path d="M3 3l18 18"></path>
                </svg>
              )}
            </div>
          )}
        </div>
        {error && <span className="Input__error">{error}</span>}
      </div>
    );
  }
}

// PasswordInput.propTypes = {
//   default: PropTypes.string,
//   name: PropTypes.string,
//   placeholder: PropTypes.string,
//   label: PropTypes.string,
//   gap: PropTypes.oneOf(['sm', 'md', 'lg']),
//   size: PropTypes.oneOf(['lg', 'sm']),
//   onChange: PropTypes.func,
//   error: PropTypes.string,
//   disabled: PropTypes.bool,
// };

// PasswordInput.defaultProps = {
//   default: '',
//   name: '',
//   label: '',
//   placeholder: '',
//   gap: 'md',
//   size: 'sm',
//   onChange: () => {},
//   error: '',
//   disabled: false,
// };

export default PasswordInput;
